module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point03_03_spectacular_spot-0a48e3032191659e76723d68e103d874.jpg";